<template>
    <div class="workflow-process-list-pane">
        <div class="toolbar">

            <el-date-picker v-model="localQuery.createdAtRange" type="daterange" value-format="yyyy-MM-dd"
                format="yyyy-MM-dd" range-separator="至" start-placeholder="创建开始" end-placeholder="创建结束" size="small"
                style="width: 260px" clearable @change="emitReload" />
            <template v-if="scope === 'all'">
                <el-select v-model="localQuery.initiatorId" clearable filterable placeholder="创建人" size="small"
                    style="width: 160px" @change="emitReload">
                    <el-option v-for="u in adminOptions" :key="u.id" :label="formatAdminLabel(u)" :value="u.id" />
                </el-select>
            </template>
            <el-select v-model="localQuery.currentHandlerId" clearable filterable placeholder="当前处理人" size="small"
                style="width: 150px" @change="emitReload">
                <el-option v-for="u in adminOptions" :key="u.id" :label="formatAdminLabel(u)" :value="u.id" />
            </el-select>
            <el-select v-model="localQuery.statusList" multiple clearable placeholder="流程状态" size="small"
                style="width: 200px" @change="emitReload">
                <el-option v-for="opt in processStatusOpts" :key="opt.value" :label="opt.label" :value="opt.value" />
            </el-select>
            <template v-if="scope === 'all'">
                <el-select v-model="localQuery.tag" clearable placeholder="标签" size="small" style="width: 130px"
                    @change="emitReload">
                    <el-option v-for="(tag, idx) in workflowTagOptions" :key="idx" :label="tag" :value="tag" />
                </el-select>
            </template>

            <el-select v-model="localQuery.relatedPartyRole" clearable filterable placeholder="关联方角色" size="small"
                style="width: 140px" @change="onRelatedPartyRoleChange">
                <el-option v-for="(opt, idx) in relatedPartyRoleOpts" :key="idx" :label="opt.label"
                    :value="opt.value" />
            </el-select>
            <el-select v-model="localQuery.relatedPartyId" filterable clearable placeholder="关联方" size="small"
                style="width: 180px" :disabled="!localQuery.relatedPartyRole" v-loading="listFilterRelatedPartyLoading"
                @change="emitReload">
                <el-option v-for="item in listFilterRelatedPartyOptions" :key="item.relatedPartyId"
                    :label="item.relatedPartyName" :value="item.relatedPartyId" />
            </el-select>

            <el-input v-model="localQuery.remarkKeyword" placeholder="备注" size="small" clearable style="width: 140px"
                @keyup.enter.native="emitReload" />
            <el-button type="primary" size="small" icon="el-icon-search" @click="emitReload">查询</el-button>
            <el-button type="success" size="small" icon="el-icon-plus" @click="$emit('open-create')">新建流程</el-button>
        </div>
        <el-table v-loading="loading" :data="list" stripe max-height="560" size="small">
            <el-table-column type="index" width="50" label="#" />
            <el-table-column prop="processNo" label="流程编号" min-width="140" show-overflow-tooltip />
            <el-table-column prop="tag" label="标签" width="100" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.tag || "-" }}</template>
            </el-table-column>
            <el-table-column v-if="scope === 'all'" label="创建人" width="100" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.initiatorId | enumTransfer(adminOptions, 'id', 'name')
                    }}</template>
            </el-table-column>
            <el-table-column prop="questionTitle" label="标题" min-width="160" show-overflow-tooltip />
            <el-table-column prop="questionDescription" label="任务描述" min-width="260" show-overflow-tooltip />
            <el-table-column prop="remark" label="备注" min-width="140" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.remark || "-" }}</template>
            </el-table-column>
            <el-table-column label="状态" width="100">
                <template slot-scope="scope">{{ scope.row.status | enumTransfer(processStatusOpts) }}</template>
            </el-table-column>
            <el-table-column prop="currentHandlerIds" label="当前处理人" width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="scope.row.currentHandlerIds">{{ scope.row.currentHandlerIds |
                        enumTransfer(adminOptions, 'id', 'name') }}</span>
                    <span v-else>-</span>
                </template>
            </el-table-column>
            <el-table-column label="关联方" min-width="140" show-overflow-tooltip>
                <template slot-scope="scope">{{ formatRelatedParty(scope.row) }}</template>
            </el-table-column>
            <el-table-column label="处理方式" min-width="160" show-overflow-tooltip>
                <template slot-scope="scope">
                    <workflow-handle-biz-tag :handle-type="scope.row.handleType"
                        :handle-biz-id="scope.row.handleBizId" />
                </template>
            </el-table-column>
            <el-table-column prop="lastResult" label="处理结果" min-width="260" show-overflow-tooltip />
            <el-table-column prop="deadline" label="截止时间" width="140">
                <template slot-scope="scope">{{ scope.row.deadline || "-" }}</template>
            </el-table-column>
            <el-table-column prop="createdAt" label="创建时间" width="140">
                <template slot-scope="scope">{{ scope.row.createdAt || "-" }}</template>
            </el-table-column>
            <el-table-column label="操作" :width="scope === 'mine' ? 280 : 180" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="$emit('detail', scope.row.id)">详情</el-button>
                    <el-button type="text" size="small" @click="$emit('edit', scope.row)">修改</el-button>
                    <el-button type="text" size="small" @click="$emit('remark', scope.row)">改备注</el-button>
                    <el-button v-if="canEditDeadline(scope.row)" type="text" size="small"
                        @click="$emit('deadline', scope.row)">改截止</el-button>
                    <el-button type="text" size="small" @click="$emit('logs', scope.row)">日志</el-button>
                    <el-button v-if="scope.row.status === 'TEMP_SAVE'" type="text" size="small" style="color: #f56c6c"
                        @click="$emit('delete', scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="pager" background layout="total, prev, pager, next, sizes" :page-sizes="[10, 20, 50]"
            :current-page.sync="localPage.current" :page-size.sync="localPage.size" :total="localPage.total"
            @size-change="emitReload" @current-change="emitLoadAfterPageTurn" />
    </div>
</template>

<script>
import WorkflowHandleBizTag from "@/components/WorkflowHandleBizTag";

function cloneProcessQuery(q) {
    if (!q) return {};
    const c = { ...q };
    if (Array.isArray(q.statusList)) c.statusList = [...q.statusList];
    if (Array.isArray(q.createdAtRange)) c.createdAtRange = [...q.createdAtRange];
    return c;
}

function clonePage(p) {
    if (!p) return { current: 1, size: 10, total: 0 };
    return { ...p };
}

export default {
    name: "WorkflowProcessListPane",
    components: { WorkflowHandleBizTag },
    props: {
        /** 'all' | 'mine' */
        scope: {
            type: String,
            required: true,
            validator: (v) => v === "all" || v === "mine"
        },
        query: { type: Object, required: true },
        page: { type: Object, required: true },
        loading: { type: Boolean, default: false },
        list: { type: Array, default: () => [] },
        adminOptions: { type: Array, default: () => [] },
        workflowTagOptions: { type: Array, default: () => [] },
        processStatusOpts: { type: Array, default: () => [] },
        relatedPartyRoleOpts: { type: Array, default: () => [] },
        listFilterRelatedPartyOptions: { type: Array, default: () => [] },
        listFilterRelatedPartyLoading: { type: Boolean, default: false },
        formatRelatedParty: { type: Function, required: true },
    },
    data() {
        return {
            localQuery: {},
            localPage: { current: 1, size: 10, total: 0 }
        };
    },
    watch: {
        query: {
            immediate: true,
            deep: true,
            handler(val) {
                this.localQuery = cloneProcessQuery(val);
            }
        },
        page: {
            immediate: true,
            deep: true,
            handler(val) {
                this.localPage = clonePage(val);
            }
        }
    },
    methods: {
        formatAdminLabel(u) {
            return `${u.name || ""}`;
        },
        /** 暂存 / 待处理 / 进行中可改截止时间 */
        canEditDeadline(row) {
            if (!row) return false;
            const s = row.status;
            return s === "TEMP_SAVE" || s === "PENDING" || s === "IN_PROGRESS";
        },
        /** 先于 reload/load，把本地编辑同步回父组件（避免 watch 异步晚于 @change） */
        pushStateToParent() {
            this.$emit("update:query", cloneProcessQuery(this.localQuery));
            this.$emit("update:page", clonePage(this.localPage));
        },
        emitReload() {
            this.pushStateToParent();
            this.$emit("reload");
        },
        emitLoadAfterPageTurn() {
            this.pushStateToParent();
            this.$emit("load");
        },
        onRelatedPartyRoleChange() {
            this.pushStateToParent();
            this.$emit("related-party-role-change");
        }
    }
};
</script>

<style lang="less" scoped>
.workflow-process-list-pane {
    .toolbar {
        margin-bottom: 12px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
    }

    .pager {
        margin-top: 12px;
        text-align: right;
    }
}
</style>
